import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Loader from '../../../components/Loader';
import ApiService from '../../../services/ApiService';
import { toast } from 'react-toastify';

const BusinessTypeForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoader, setIsLoader] = useState(false);
  const [formData, setFormData] = useState({ title: '', title_ar: '' });

  useEffect(() => { if (id) fetchData(); }, [id]);

  const fetchData = async () => {
    try {
      setIsLoader(true);
      const res = await ApiService.request({ method: 'GET', url: `admin/business-types/${id}` });
      if (res.data.status) setFormData(res.data.data);
      else toast.error(res.data.message);
    } catch (_) {}
    finally { setIsLoader(false); }
  };

  const handleChange = (e) => setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoader(true);
      const res = await ApiService.request({
        method: 'POST',
        url: `admin/business-types/createOrUpdate/${id || ''}`,
        data: formData,
      });
      if (res.data.status) {
        toast.success(res.data.message);
        navigate('/admin/business-types');
      } else {
        toast.error(res.data.message);
      }
    } catch (_) {}
    finally { setIsLoader(false); }
  };

  return (
    <div className="d-flex flex-column flex-column-fluid">
      <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
        <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
          <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
              {id ? 'Edit' : 'Add New'} Business Type
            </h1>
            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
              <li className="breadcrumb-item text-muted">
                <Link to="/admin/dashboard" className="text-muted text-hover-primary">Dashboard</Link>
              </li>
              <li className="breadcrumb-item"><span className="bullet bg-gray-400 w-5px h-2px"></span></li>
              <li className="breadcrumb-item text-muted">
                <Link to="/admin/business-types" className="text-muted text-hover-primary">Business Types</Link>
              </li>
              <li className="breadcrumb-item"><span className="bullet bg-gray-400 w-5px h-2px"></span></li>
              <li className="breadcrumb-item text-muted">{id ? 'Edit' : 'Add'}</li>
            </ul>
          </div>
        </div>
      </div>

      <div id="kt_app_content" className="app-content flex-column-fluid">
        <div id="kt_app_content_container" className="app-container container-xxl">
          <div className="card">
            <div className="card-body pt-6">
              <form onSubmit={handleSubmit}>
                <div className="row g-9 my-3">
                  <div className="col-md-6 fv-row">
                    <label className="required fs-6 fw-semibold mb-2">Title</label>
                    <input
                      type="text"
                      className="form-control form-control-solid"
                      placeholder="e.g. Restaurant"
                      name="title"
                      required
                      value={formData.title}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6 fv-row">
                    <label className="fs-6 fw-semibold mb-2">Title Arabic</label>
                    <input
                      type="text"
                      className="form-control form-control-solid"
                      placeholder="Arabic title"
                      name="title_ar"
                      value={formData.title_ar || ''}
                      onChange={handleChange}
                      dir="rtl"
                    />
                  </div>
                </div>

                <div className="row g-9 my-3">
                  <div className="text-center">
                    <Link to="/admin/business-types" className="btn btn-light me-3">Back</Link>
                    <button type="submit" className="btn btn-base" disabled={isLoader}>
                      {isLoader ? <Loader size="20" color="white" text="Saving…" /> : 'Submit'}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessTypeForm;
